import {Injectable} from "@angular/core";
import {User} from "../models/User/user";
import { BehaviorSubject } from "rxjs";
import {environment} from "src/environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {map} from "rxjs/operators";
import {IWalletOverview, UserWallet, WalletOverview} from "../models/User/user-wallet";

@Injectable({
    providedIn: "root"
})
export class UserHttpClientService {
    private readonly endpoint = environment.backendBaseUrl;

    private userSource = new BehaviorSubject<User>(null);
    user = this.userSource.asObservable();

    constructor(private http: HttpClient) {
    }

    // TODO: Duhet te vij vet is_company edhe jo te kalkulohet ne front
    getUserDetails() {
        return this.http.get<User>(`${this.endpoint}/api/user/details`).pipe(
            map((user: User) => {
                user.is_company = !!user.company_name;
                this.userSource.next(user)
                return user;
            })
        );
    }

    // ? Duke qene se lidhja me wallet eshte 1 : 1, por ne te ardhmen
    // ? mund te ndodh qe 1 user te kete me shume se nje wallet sepse 1
    // ? wallet lidhet me nje monedhe, per momentin kemi vetem 1 monedhe,
    // ? qe do te thote 1 : 1
    getUserWallets() {
        return this.http.get<UserWallet[]>(`${this.endpoint}/api/user/wallets`);
    }

    getWalletOverview() {
        return this.http.get<WalletOverview[]>(`${this.endpoint}/api/user/wallet-overview`);
    }

    getUserName() {
        return this.http.get<string>(`${this.endpoint}/api/user/username`, {
            responseType: "text" as "json"
        });
    }

    getContracts() {
        return this.http.get(this.endpoint + "/api/user/contracts");
    }

    updateUserDetails(user: {
        firstName: string,
        lastName: string,
        companyName: string,
        administratorFirstName: string,
        administratorLastName: string,
        idCard: string,
        celNr: string
    }) {
        return this.http.post(this.endpoint + "/api/user/update", user);
    }

    // tslint:disable-next-line:max-line-length
    sendComplaintOrImprovement = (obj) => this.http.post<string>(this.endpoint + "/api/user/complain", obj, {responseType: "text" as "json"});
}
